import { z } from "zod";

export const AssetType = z.enum(["Mitarbeiter", "Prozess", "Device", "Daten", "Information", "Sonstiges"]);
export type AssetType = z.infer<typeof AssetType>;

export const Classification = z.enum(["öffentlich", "intern", "vertraulich"]);
export type Classification = z.infer<typeof Classification>;

export const Asset = z.object({
  id: z.number().int().positive(),
  code: z.string(),
  name: z.string(),
  type: AssetType,
  description: z.string().nullable(),
  classification: Classification.nullable(),
  assetOwnerUserId: z.number().int().nullable(),
  riskOwnerUserId: z.number().int().nullable(),
  createdAt: z.number().int(),
  updatedAt: z.number().int(),
});
export type Asset = z.infer<typeof Asset>;

export const AssetCreate = z.object({
  code: z.string().min(1).max(80).optional(),
  name: z.string().min(1).max(500),
  type: AssetType,
  description: z.string().max(5000).nullable().optional(),
  classification: Classification.nullable().optional(),
  assetOwnerUserId: z.number().int().positive().nullable().optional(),
  riskOwnerUserId: z.number().int().positive().nullable().optional(),
});
export type AssetCreate = z.infer<typeof AssetCreate>;

export const AssetUpdate = AssetCreate.partial();
export type AssetUpdate = z.infer<typeof AssetUpdate>;
